// Adaptive layout shell.
// Modes:
//   default       – mobile-first centered (max 480px)
//   wide          – ~1280px for guest gallery / upload
//   dashboard     – ultrawide (1640px) with custom header (logo + slogan + actions)
import React from "react";
import AnimatedBackground from "./AnimatedBackground";

export default function PageShell({
  children,
  headerRight = null,
  headerLeft = null,
  headerCenter = null,
  wide = false,
  dashboard = false,
  hideHeader = false,
}) {
  const maxWidth = dashboard ? 1640 : wide ? 1280 : 480;
  return (
    <div className="min-h-screen relative">
      <AnimatedBackground />
      <div
        className="mx-auto"
        style={{ maxWidth, padding: dashboard ? "20px 28px 80px" : "16px 24px 80px" }}
      >
        {!hideHeader && (
          <header
            className={dashboard
              ? "grid grid-cols-[auto_1fr_auto] items-center gap-4 mb-6"
              : "flex items-center justify-between mb-4"}
            style={{ minHeight: dashboard ? 64 : 44 }}
            data-testid="page-header"
          >
            <div className="flex items-center">{headerLeft}</div>
            <div className={dashboard ? "flex items-center justify-center" : ""}>{headerCenter}</div>
            <div className="flex items-center justify-end">{headerRight}</div>
          </header>
        )}
        {children}
      </div>
    </div>
  );
}
